import bronzeBadge from "../assets/badges/bronze_badge.png";
import silverBadge from "../assets/badges/silver_badge.png";
import goldBadge from "../assets/badges/gold_badge.png";
import eliteBadge from "../assets/badges/elite_badge.png";
import legendBadge from "../assets/badges/legend_badge.png";
import mythicBadge from "../assets/badges/mythic_badge.png";
import masterBadge from "../assets/badges/master_badge.png";
import infinityMasterBadge from "../assets/badges/infinty_master_badge.png";

export const normalizeAvatarName = (name) =>
  name
    .toLowerCase()
    .replace(/[()]/g, "")
    .replace(/[^a-z0-9]/gi, "_")
    .replace(/_+/g, "_")
    .trim();

const DEFAULT_DIRECTION_FRAMES = {
  down: [0, 1, 2, 3],
  left: [4, 5, 6, 7],
  right: [8, 9, 10, 11],
  up: [12, 13, 14, 15],
};

const ZAY_SMALL_SPRITE_DIRECTION_FRAMES = {
  down: [0, 4, 8, 12],
  up: [1, 5, 9, 13],
  right: [2, 6, 10, 14],
  left: [3, 7, 11, 15],
};

const SMALL_RPG_SPRITE_CONFIG = {
  frameWidth: 128,
  frameHeight: 128,
  worldScale: 0.375,
  collisionScale: 1,
  directionFrames: ZAY_SMALL_SPRITE_DIRECTION_FRAMES,
};

const IO_SPRITE_CONFIG = {
  frameWidth: 128,
  frameHeight: 192,
  worldScale: 0.72,
  collisionScale: 1,
  trimBottom: 28,
  directionFrames: DEFAULT_DIRECTION_FRAMES,
};

export const DEFAULT_AVATAR_SPRITE_CONFIG = {
  frameWidth: 128,
  frameHeight: 192,
  worldScale: 1,
  collisionScale: 1,
  showCollisionDebug: false,
  directionFrames: DEFAULT_DIRECTION_FRAMES,
};

export const AVATAR_SPRITE_CONFIGS = {
  io: IO_SPRITE_CONFIG,
  io_default: IO_SPRITE_CONFIG,
  infinty_orb: IO_SPRITE_CONFIG,
  infinity_orb: IO_SPRITE_CONFIG,
  io_green: IO_SPRITE_CONFIG,
  io_blue: IO_SPRITE_CONFIG,
  io_orange: IO_SPRITE_CONFIG,
  io_red: IO_SPRITE_CONFIG,
  io_white: IO_SPRITE_CONFIG,
  io_void: IO_SPRITE_CONFIG,
  i_o_blue: IO_SPRITE_CONFIG,
  i_o_orange: IO_SPRITE_CONFIG,
  i_o_pink: IO_SPRITE_CONFIG,
  i_o_purple: IO_SPRITE_CONFIG,
  i_o_red: IO_SPRITE_CONFIG,
  i_o_void: IO_SPRITE_CONFIG,
  i_o_white: IO_SPRITE_CONFIG,
  i_o_yellow: IO_SPRITE_CONFIG,
  zay: {
    ...SMALL_RPG_SPRITE_CONFIG,
    showCollisionDebug: false,
  },
  yuna: SMALL_RPG_SPRITE_CONFIG,
  kolby: SMALL_RPG_SPRITE_CONFIG,
  toshi: SMALL_RPG_SPRITE_CONFIG,
  glyde: SMALL_RPG_SPRITE_CONFIG,
};

export const SPRITES_MAP = {
  // zay: require("../assets/avatars/zay/zay.png"),
  zay: require("../assets/avatars/zay/zay-small-sprite.png"),
  // yuna: require("../assets/avatars/yuna/yuna-walking-sprite.png"),
  yuna: require("../assets/avatars/yuna/yuna-small-sprite.png"),
  // kolby: require("../assets/avatars/kolby/kolby-walking-sprite.png"),
  kolby: require("../assets/avatars/kolby/kolby-small-sprite.png"),
  toshi: require("../assets/avatars/toshi-small-sprite.png"),
  glyde: require("../assets/avatars/glyde-small-sprite.png"),
  deads: require("../assets/avatars/deads/deads.png"),
  infinty_orb: require("../assets/avatars/InfintyOrbs/green.png"),
  io_default: require("../assets/avatars/InfintyOrbs/green.png"),
  i_o_red: require("../assets/avatars/InfintyOrbs/red.png"),
  i_o_blue: require("../assets/avatars/InfintyOrbs/blue.png"),
  i_o_yellow: require("../assets/avatars/InfintyOrbs/yellow.png"),
  i_o_purple: require("../assets/avatars/InfintyOrbs/purple.png"),
  i_o_orange: require("../assets/avatars/InfintyOrbs/orange.png"),
  i_o_pink: require("../assets/avatars/InfintyOrbs/pink.png"),
  i_o_void: require("../assets/avatars/InfintyOrbs/void.png"),
  i_o_white: require("../assets/avatars/InfintyOrbs/white.png"),
};

export const getAvatarSpriteConfig = (avatarNameOrKey = "") =>
  AVATAR_SPRITE_CONFIGS[normalizeAvatarName(avatarNameOrKey)] ||
  DEFAULT_AVATAR_SPRITE_CONFIG;

export const getAvatarDirectionFrames = (avatarNameOrKey = "", direction) =>
  getAvatarSpriteConfig(avatarNameOrKey).directionFrames[direction] ||
  DEFAULT_DIRECTION_FRAMES[direction] ||
  DEFAULT_DIRECTION_FRAMES.down;

export const getAvatarDirectionFromHeading = (heading) =>
  (
    {
      0: "down",
      270: "left",
      90: "right",
      180: "up",
    }[heading] || "down"
  );

export const getAvatarFrameForDirection = (
  avatarNameOrKey = "",
  heading,
  frameIndex = 0,
) => {
  const direction = getAvatarDirectionFromHeading(heading);
  const frames = getAvatarDirectionFrames(avatarNameOrKey, direction);
  return frames[frameIndex] ?? frames[0] ?? 0;
};

export const scaleAvatarBodySize = (avatarNameOrKey = "", size = {}) => {
  const collisionScale = getAvatarSpriteConfig(avatarNameOrKey).collisionScale || 1;
  return {
    width: Math.max(1, Math.round((size.width || 0) * collisionScale)),
    height: Math.max(1, Math.round((size.height || 0) * collisionScale)),
  };
};

export const scaleAvatarBodyOffset = (avatarNameOrKey = "", offset = {}) => {
  const collisionScale = getAvatarSpriteConfig(avatarNameOrKey).collisionScale || 1;
  return {
    x: Math.round((offset.x || 0) * collisionScale),
    y: Math.round((offset.y || 0) * collisionScale),
  };
};

export const STICKERS_MAP = {
  bronze: bronzeBadge,
  silver: silverBadge,
  gold: goldBadge,
  elite: eliteBadge,
  legend: legendBadge,
  mythic: mythicBadge,
  master_t1: masterBadge,
  master_t2: infinityMasterBadge,

  alien_boy:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Falien-boy.png?alt=media&token=c2efdef0-ab29-44db-863f-56bb5b52b102",
  azuki:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fazuki.png?alt=media&token=8c855803-807f-4961-ba43-069d187d2451",
  big_bomber:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0014_Layer-11.png?alt=media&token=d3a14b2e-7007-485a-a57a-aafd2c697931",
  bigfoot404:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fbig-foot.png?alt=media&token=f29ae2d1-1f68-41a9-b71b-74e3b4fc61c8",
  cross_swords:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0003_Layer-22.png?alt=media&token=f80fd824-e60d-45b8-b1c2-6c818bbb148a",
  crosshair:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0013_Layer-12.png?alt=media&token=aaf176bc-fd32-4e13-8405-8876b96a309d",
  fight:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0009_Layer-16.png?alt=media&token=e69a7d2f-1a81-428e-90a4-0447d2344ee2",
  fire: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0010_Layer-15.png?alt=media&token=1a9f6248-5751-4ef7-93cf-ecf7346c27f4",
  friends:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0016_Layer-9.png?alt=media&token=e759ea3f-2109-4843-9143-f4f972871a09",
  grass:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0007_Layer-18.png?alt=media&token=039beb32-f209-4299-8b1f-9801d06b44a3",
  health:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0006_Layer-19.png?alt=media&token=25af4e67-f347-41aa-a445-e80afcd95649",
  ice: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0005_Layer-20.png?alt=media&token=2be08bc8-483d-4a50-8194-9c9725631705",
  infinity_gem:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0001_Layer-28.png?alt=media&token=4a3c913e-ba57-4e93-809d-f6a5aacd24db",
  infinity_token:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0000_Layer-29.png?alt=media&token=94db5f98-deec-4178-bf2b-30eb19d58843",
  king_me:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0012_Layer-13.png?alt=media&token=b9e6a9b6-7a5d-480c-85ec-80244f8f252d",
  lightning:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0011_Layer-14.png?alt=media&token=a5afac7a-239e-4512-9c2a-78568bca888d",
  little_lambs:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Flambs.png?alt=media&token=28ab1ce6-d2e8-4e72-94d8-e7d0b03a7099",
  play_it:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0015_Layer-10.png?alt=media&token=2164f550-679e-4bce-aa14-e773ba9e7a27",
  quakk:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fquakk.png?alt=media&token=cd487334-f7c0-4e86-a839-4865755ed581",
  raise_the_flag:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0008_Layer-17.png?alt=media&token=bfc9ddc8-58ed-4920-8701-dc73cd41ae0e",
  royale_logo:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0002_Layer-27.png?alt=media&token=60412493-3942-4000-915b-8b2a96780db2",
  solana_deads:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2FSDs.png?alt=media&token=9ad4c47e-1e8c-4d39-a0be-16e9bfa46a63",
  spin_wheel:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0003_Layer-26.png?alt=media&token=f3ffb0b0-6d7e-4239-86f5-277ad9148f3f",
  tads: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Ftads.png?alt=media&token=f7744437-3f32-4624-80fb-942e4dbd0285",
  the_wilds:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fwilds.png?alt=media&token=8eaacc83-2939-44a5-8093-6fb29b4ad242",
  to_the_moon:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0004_Layer-21.png?alt=media&token=615b18ec-7436-472e-8579-8230ae8a7f25",
  void: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0002_Layer-23.png?alt=media&token=40fec193-7aec-4539-9a8e-4f0ec6f8978c",
  water:
    "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/stickers%2Fstickers_0001_Layer-24.png?alt=media&token=042c31a8-a336-4030-861a-87a83f05946d",
};
